import * as Yup from 'yup';
import { emailRule, makePasswordRule, confirmPasswordRule, phoneNumberRule } from '../../../Shared/Utils/FormValidation';

/**
 * Signup initial values object containing empty fields for user registration
 * Contains user's full name, email, industry, organization name, role,
 * how they heard about the service, password, and password confirmation, phone_number
 */
export const signupInitialValues = {
  firstname: '',
  lastname: '',
  preferred_name: '',
  email: '',
  phone_number: '',
  dob: '',
  password: '',
  confirm_password: '',
};
/**Signup Schema */
export const signupSchema = Yup.object({
  // firstname: requiredString('first name'),
  // lastname: requiredString('last name'),
  email: emailRule,
  // industries: Yup.array().min(1, 'Select at least one industry').max(3, 'You can select maximum 3 industries'),
  // organization_name: requiredString('Organization name'),
  // role: Yup.string().nullable(),
  // how_did_you_hear_about_xtergrity: Yup.string().nullable(),
  phone_number: phoneNumberRule,
  password: makePasswordRule,
  confirm_password: confirmPasswordRule,
  // time_zone: Yup.string().required('Time zone is required'),
});

/**
 * Login initial values object containing empty fields for user authentication
 * Contains email, password, and remember me option
 */
export const loginInitialValues = {
  email: '',
  password: '',
  // remember: false,
};
/**Login Schema */
export const loginSchema = Yup.object({
  email: emailRule,
  password: makePasswordRule,
});

/**
 * Forgot password initial values configuration
 * Contains the default form values for the forgot password functionality
 */
export const forgotPasswordInitialValues = {
  email: '',
};
/**Forgot Password Schema */
export const forgotPasswordSchema = Yup.object({
  email: emailRule,
});

/**
 * Reset password initial values configuration
 * Contains the default form values for the reset password functionality
 */
export const resetPasswordInitialValues = {
  newPassword: '',
  confirmPassword: '',
};

/**Reset Password Schema */
export const resetPasswordSchema = Yup.object({
  newPassword: makePasswordRule,
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Passwords must match')
    .required('Confirm your password'),
});

/**
 * OTP Verification
 */
export const otpInitialValues = {
  otp: ['', '', '', '', '', ''], // array of 6
};

export const otpValidationSchema = Yup.object({
  otp: Yup.array()
    .of(Yup.string().matches(/^[0-9]$/, 'Must be a digit'))
    .length(6, 'OTP must be 6 digits')
    .required('OTP is required')
    .test('is-complete', 'Please enter valid OTP', (arr) => arr.every((val) => val && val.length === 1)),
});
